import { ComplianceFrameworks as ComplianceFrameworksEnum } from '@/api/rest/resources/types/organization';
import { NCCardComplianceFooter, NCCardComplianceFooterProps } from '@/components/NCCard/NCCard';
import { ComplianceFrameworkLogo } from '@/config/constants';

const VALID_FRAMEWORKS = new Set(Object.values(ComplianceFrameworksEnum));

export type ComplianceFrameworksWidgetProps = {
  frameworks?: string[];
} & NCCardComplianceFooterProps;

export const ComplianceFrameworks = ({ logos = [], ...props }: NCCardComplianceFooterProps) => {
  const filteredFrameworks = logos.filter((f) =>
    VALID_FRAMEWORKS.has(f as ComplianceFrameworksEnum),
  ) as ComplianceFrameworkLogo[];

  if (filteredFrameworks.length === 0) {
    return null;
  }

  return <NCCardComplianceFooter logos={filteredFrameworks} {...props} />;
};
